module.exports = __webpack_public_path__ + "img/DE05006.73bd106d.png";